import { useAccount, useConnect, useDisconnect, useSignMessage, useEnsName, useEnsAvatar } from 'wagmi';

export const useWallet = () => {
  const { address, isConnected, connector } = useAccount();
  const { connect, connectors, error: connectError, pendingConnector } = useConnect();
  const { disconnect } = useDisconnect();
  const { signMessageAsync } = useSignMessage();

  // Use Wagmi's built-in ENS hooks - they handle caching and optimization automatically
  const { data: ensName } = useEnsName({ 
    address, 
    chainId: 1, // Mainnet for ENS
    query: {
      enabled: !!address, // Only fetch if we have an address
    }
  });

  const { data: ensAvatar } = useEnsAvatar({ 
    name: ensName,
    chainId: 1, // Mainnet for ENS
    query: {
      enabled: !!ensName, // Only fetch if we have an ENS name
    }
  });

  const connectWallet = async (connectorType = 'metaMask') => {
    const connector = connectors.find(c => 
      c.id === connectorType || c.name.toLowerCase() === connectorType.toLowerCase()
    );
    if (connector) {
      connect({ connector });
    }
  };

  const signVote = async (proposalId, choice) => {
    if (!isConnected) throw new Error('Wallet not connected');
    
    const message = `I vote on proposal ${proposalId} with choice: ${choice}`;
    return await signMessageAsync({ message });
  };

  // Keep these functions for backward compatibility with your existing code
  const getEnsName = async (walletAddress = null) => {
    // If a specific address is provided, you might want different logic
    // For now, return the connected wallet's ENS name
    return ensName || null;
  };

  const getEnsAvatar = async (ensNameParam = null) => {
    // Return avatar for the provided ENS name or the connected wallet's ENS
    return ensAvatar || null;
  };

  const getEnsRecords = async (ensNameParam) => {
    // Simplified records - you can enhance this later if needed
    return {
      ensName: ensNameParam || ensName,
      ensAvatar: ensAvatar,
      hasEns: !!(ensNameParam || ensName)
    };
  };

  return {
    address,
    isConnected,
    connector,
    connectWallet,
    disconnect,
    signVote,
    signMessageAsync,
    getEnsName,
    getEnsAvatar,
    getEnsRecords,
    connectError,
    pendingConnector,
    // Direct access to ENS data for convenience
    ensName,
    ensAvatar
  };
};